import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { Typography } from '@telus-uds/components-web';

import Actions from './Actions';
import { getFormattedDate } from '../utils/utils';
import { orderStatus } from '../utils/constant';
import { useTranslationsContext } from '../context/TranslationsContext';
import { getMessage, getLastComment } from './utils';
const Row = ({ order, index, fetchOrders }) => {
  const {
    WLS: {
      DASHBOARD: {
        Submitted,
        Incomplete,
        WirelessOrder,
        PendingValidation,
        OrderType,
        Canceled,
        WaitingOnSales
      }
    },
    ORDERS: { filterByFlagsList }
  } = useTranslationsContext();

  const {
    wlsBusinessLegalName,
    status,
    updatedAt,
    createdAt,
    validatedAt,
    orderId,
    installationTypeWLS,
    isFlag = false,
    flag = ''
  } = order;

  const getStatusesMessage = () => {
    switch (status) {
      case orderStatus.validated:
        return Submitted;
      case orderStatus.pendingValidation:
        return PendingValidation;
      case orderStatus.canceled:
        return Canceled;
      case orderStatus.waitingOnSales:
        return WaitingOnSales;
      default:
        return Incomplete;
    }
  };

  return (
    <Tr style={{ background: index % 2 === 0 ? '#f9f1ff' : '#ffffff' }}>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{orderId}</Typography></Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Typography>{wlsBusinessLegalName || ''}</Typography>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Typography>{installationTypeWLS || ''}</Typography>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Typography>{getFormattedDate(createdAt, 'YYYY-MM-DD') || '-'}</Typography>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Typography>{validatedAt ? getFormattedDate(validatedAt, 'YYYY-MM-DD') : '-'}</Typography>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Typography>{getFormattedDate(updatedAt, 'YYYY-MM-DD') || '-'}</Typography>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Typography>{getStatusesMessage()}</Typography>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <div className="responsive-table__comment">
          <Typography>{getLastComment(_.get(order, 'comments.0.text', '-'))}</Typography>
        </div>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Typography>{flag ? getMessage(flag + '') : ''}</Typography>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Actions
          status={status || orderStatus.incomplete}
          order={order}
          fetchOrders={fetchOrders}
        />
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Row;
